import { Component, Input, ViewChild } from '@angular/core';
import { Translate } from '../../utils/translate';
import { FeedbackModalComponent } from '../feedback-modal/feedback-modal.component';
import { MatDatepicker } from '@angular/material/datepicker';
import { Areas, Dealers, Departaments } from '../../model/project.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OrderService } from 'src/app/core/services/order.service';
import { MatDialog } from '@angular/material/dialog';
import { ProjectType } from '../../model/projectType.enum';
import i18next from 'i18next';
import { ModalTableCostsDetailComponent } from '../modal-table-costs-detail/modal-table-costs-detail.component';
import { AuthorizerUsers, User } from '../../model/user.model';
import { StorageService } from 'src/app/core/storage/storage.service';

@Component({
  selector: 'app-project-data',
  templateUrl: './project-data.component.html',
  styleUrls: ['./project-data.component.scss']
})
export class ProjectDataComponent {
  @Input() projectData?: any;
  @Input() isModify?: boolean;
  @Input() controller?: AuthorizerUsers;
  @Input() delegatedApprover?: AuthorizerUsers;

  form!: FormGroup;
  projectTypeEnum = ProjectType;
  departaments: Departaments[] = [];
  areas: Areas[] = [];
  dealers: Dealers[] = [];
  cecos: string[] = [];
  showAreaAndDepartament = false;
  showReguForm = false;
  showOtherForm = false;
  showNewForm = false;
  selectedSubtype = '';
  selectedSpecialType = '';
  searchError = false;
  vinRepeat = false;
  vehicles: any[] = [];
  spinner = false;
  stockVehicle = false;
  filteredDealers: Dealers[] = [];
  userIsController = false;
  user!: User;

  @ViewChild('picker') picker!: MatDatepicker<any>;
  @ViewChild('datePicker') datePicker!: MatDatepicker<any>;
  @ViewChild('plateNumberPicker') plateNumberPicker!: MatDatepicker<any>;
  @ViewChild('deliveryPicker') deliveryPicker!: MatDatepicker<any>;
  @ViewChild('sopPicker') sopPicker!: MatDatepicker<any>;

  constructor(
    public translate: Translate,
    private orderService: OrderService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private storageService: StorageService
  ) {
    this.form = this.fb.group({});
  }

  displayDealerFn(dealer: Dealers): string {
    return dealer && dealer.code ? `${dealer.code} - ${dealer.name}` : '';
  }

  ngOnInit(): void {
    if (this.storageService.get('config')) {
      this.user = this.storageService.get('config');
      if (this.user.nis === this.projectData?.controller?.id) {
        this.userIsController = true;
      } else {
        this.userIsController = false;
      }
    }

    this.updateForm();
    this.showAreaAndDepartament =
      this.projectData?.projectSubType === this.projectTypeEnum.NEW ||
      this.projectData?.projectSubType === this.projectTypeEnum.REGU;

    this.showReguForm =
      this.projectData?.projectSubType === this.projectTypeEnum.REGU;
    this.showOtherForm =
      this.projectData?.projectSubType === this.projectTypeEnum.OTHER;
    this.showNewForm =
      this.projectData?.projectSubType === this.projectTypeEnum.NEW;

    if (this.showReguForm && !!this.projectData?.projectStockVehicle) {
      this.form.get('model')?.clearValidators();
      this.form.get('model')?.updateValueAndValidity();
      this.form.get('color')?.clearValidators();
      this.form.get('color')?.updateValueAndValidity();
      this.form.get('finish')?.clearValidators();
      this.form.get('finish')?.updateValueAndValidity();
      this.form.get('tmaimg')?.clearValidators();
      this.form.get('tmaimg')?.updateValueAndValidity();
      this.stockVehicle = true;
    }

    if (
      this.projectData?.costs &&
      this.projectData?.costs?.especialType &&
      (this.projectData.costs.especialType === 'PRESERIE' ||
        this.projectData.costs.especialType === 'PRE_PRESERIE' ||
        this.projectData.costs.especialType === 'ZEROSERIE')
    ) {
      this.form.get('cops')?.setValidators(Validators.required);
      this.form.get('cops')?.updateValueAndValidity();
    }

    this.orderService.getProjectAreas().subscribe({
      next: (data: any) => {
        this.areas = data;
      },
      error: (error) => {
        console.error('Error fetching authorizers:', error);
      },
      complete: () => {
        console.log('Fetch complete');
      }
    });

    this.orderService.getProjectDealers().subscribe({
      next: (data: any) => {
        this.dealers = data;

        this.filterDealers(this.form.get('dealerCode')?.value);

        this.updateDealerCodeInit(this.projectData?.dealer.code);
      },
      error: (error) => {
        console.error('Error fetching authorizers:', error);
      },
      complete: () => {
        console.log('Fetch complete');
      }
    });

    if (this.projectData?.department.area) {
      this.areaChange();
    }
  }

  onSpecialTypeChange(): void {
    this.selectedSpecialType = this.form.value.specialType;
    this.form.get('projectType')?.setValue('EMPTY');
    this.form.get('projectType')?.enable();
    this.form.get('projectML')?.enable();
    this.form.get('cops')?.clearValidators();
    this.form.get('cops')?.updateValueAndValidity();

    if (
      this.selectedSpecialType !== 'PROTOTYPE' &&
      this.selectedSpecialType !== 'SERIE'
    ) {
      this.form.get('preseriesCost')?.setValue(null);
      this.form.get('seriesCost')?.setValue(null);
      this.form.get('preseriesCost')?.setValidators(Validators.required);
      this.form.get('seriesCost')?.setValidators(Validators.required);
      this.form.get('preseriesCost')?.updateValueAndValidity();
      this.form.get('seriesCost')?.updateValueAndValidity();
    }
    if (
      this.selectedSpecialType === 'PROTOTYPE' ||
      this.selectedSpecialType === 'SERIE'
    ) {
      this.form.get('preseriesType')?.setValue('EMPTY');
      this.form.get('preseriesType')?.disable({ emitEvent: false });
      this.form.get('projectType')?.setValue('EMPTY');
      this.form.get('projectType')?.disable({ emitEvent: false });
      this.form.get('projectML')?.disable({ emitEvent: false });
      this.form.get('preseriesCost')?.setValue(0);
      this.form.get('seriesCost')?.setValue(0);
      this.form.get('preseriesCost')?.clearValidators();
      this.form.get('seriesCost')?.clearValidators();
      this.form.get('preseriesCost')?.updateValueAndValidity();
      this.form.get('seriesCost')?.updateValueAndValidity();
    } else if (
      this.selectedSpecialType === 'PRESERIE' &&
      this.form.value.projectType === 'EMPTY'
    ) {
      this.form.get('preseriesType')?.setValue('PVS');
      this.form.get('preseriesType')?.disable({ emitEvent: false });
      this.form.get('preseriesCost')?.setValue(0);
      this.form.get('seriesCost')?.setValue(0);
      this.form.get('preseriesCost')?.clearValidators();
      this.form.get('seriesCost')?.clearValidators();
      this.form.get('preseriesCost')?.updateValueAndValidity();
      this.form.get('seriesCost')?.updateValueAndValidity();
      this.form.get('cops')?.setValidators(Validators.required);
      this.form.get('cops')?.updateValueAndValidity();
    } else if (
      this.selectedSpecialType === 'PRESERIE' &&
      this.form.value.projectType !== 'EMPTY'
    ) {
      this.form.get('preseriesType')?.setValue('PVS');
      this.form.get('preseriesType')?.disable({ emitEvent: false });
      this.form.get('preseriesCost')?.setValue(null);
      this.form.get('seriesCost')?.setValue(null);
      this.form.get('preseriesCost')?.setValidators(Validators.required);
      this.form.get('seriesCost')?.setValidators(Validators.required);
      this.form.get('preseriesCost')?.updateValueAndValidity();
      this.form.get('seriesCost')?.updateValueAndValidity();
      this.form.get('cops')?.setValidators(Validators.required);
      this.form.get('cops')?.updateValueAndValidity();
    } else if (this.selectedSpecialType === 'PRE_PRESERIE') {
      this.form.get('preseriesType')?.setValue('VFF');
      this.form.get('preseriesType')?.disable({ emitEvent: false });
      this.form.get('preseriesCost')?.setValue(0);
      this.form.get('seriesCost')?.setValue(0);
      this.form.get('preseriesCost')?.clearValidators();
      this.form.get('seriesCost')?.clearValidators();
      this.form.get('cops')?.setValidators(Validators.required);
      this.form.get('cops')?.updateValueAndValidity();
    } else if (this.selectedSpecialType === 'ZEROSERIE') {
      this.form.get('preseriesType')?.setValue('ZEROSERIE');
      this.form.get('preseriesType')?.disable({ emitEvent: false });
      this.form.get('preseriesCost')?.setValue(0);
      this.form.get('seriesCost')?.setValue(0);
      this.form.get('preseriesCost')?.clearValidators();
      this.form.get('seriesCost')?.clearValidators();
      this.form.get('cops')?.setValidators(Validators.required);
      this.form.get('cops')?.updateValueAndValidity();
    } else if (this.selectedSpecialType === 'PRESS') {
      this.form.get('preseriesType')?.setValue('EMPTY');
      this.form.get('preseriesType')?.enable();
      this.form.get('pressSubtype')?.setValidators(Validators.required);
      this.form.get('pressSubtype')?.updateValueAndValidity();
      this.form.get('projectType')?.setValue('EMPTY');
      this.form.get('projectType')?.disable({ emitEvent: false });
      this.form.get('projectML')?.disable({ emitEvent: false });
    }

    if (this.form.get('cops')?.invalid) {
      const dialogRef = this.dialog.open(FeedbackModalComponent, {
        width: '400px',
        data: {
          text: i18next.t('copsRequired'),
          close: true,
          theme: 'light'
        }
      });
      dialogRef.afterClosed().subscribe(() => {
        setTimeout(() => {
          const element = document.getElementById('cops-anchor');
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 0);
      });
    }
  }

  onPreseriesTypeChange(): void {
    const selectedPreseriesType = this.form.value.preseriesType;
    this.form.get('projectType')?.setValue('EMPTY');
    this.form.get('projectType')?.enable();
    this.form.get('projectML')?.enable();

    if (selectedPreseriesType === 'EMPTY') {
      this.form.get('projectType')?.setValue('EMPTY');
      this.form.get('projectType')?.disable({ emitEvent: false });
      this.form.get('projectML')?.disable({ emitEvent: false });
    }
  }

  onProjectTypeChange(): void {
    this.selectedSpecialType = this.form.value.specialType;
    if (
      this.selectedSpecialType === 'PRESERIE' &&
      this.form.value.projectType === 'EMPTY'
    ) {
      this.form.get('preseriesType')?.setValue('PVS');
      this.form.get('preseriesType')?.disable({ emitEvent: false });
      this.form.get('preseriesCost')?.setValue(0);
      this.form.get('seriesCost')?.setValue(0);
      this.form.get('preseriesCost')?.clearValidators();
      this.form.get('seriesCost')?.clearValidators();
      this.form.get('preseriesCost')?.updateValueAndValidity();
      this.form.get('seriesCost')?.updateValueAndValidity();
    } else if (
      this.selectedSpecialType === 'PRESERIE' &&
      this.form.value.projectType !== 'EMPTY'
    ) {
      this.form.get('preseriesType')?.setValue('PVS');
      this.form.get('preseriesType')?.disable({ emitEvent: false });
      this.form.get('preseriesCost')?.setValue(null);
      this.form.get('seriesCost')?.setValue(null);
      this.form.get('preseriesCost')?.setValidators(Validators.required);
      this.form.get('seriesCost')?.setValidators(Validators.required);
      this.form.get('preseriesCost')?.updateValueAndValidity();
      this.form.get('seriesCost')?.updateValueAndValidity();
    }
  }

  updateForm(): void {
    switch (this.projectData?.projectSubType) {
      case this.projectTypeEnum.NEW:
        this.form.addControl(
          'area',
          this.fb.control(
            this.projectData?.department.area.id,
            Validators.required
          )
        );
        this.form.addControl(
          'departament',
          this.fb.control(
            { value: this.projectData?.department.id },
            Validators.required
          )
        );
        this.form.addControl(
          'reference',
          this.fb.control(this.projectData?.orderReference)
        );
        this.form.addControl(
          'date',
          this.fb.control(this.projectData?.requiredDate, Validators.required)
        );
        this.form.addControl(
          'returnDate',
          this.fb.control(this.projectData?.returnDate, Validators.required)
        );
        this.form.addControl('sop', this.fb.control(this.projectData?.sop));
        this.form.addControl('cops', this.fb.control(this.projectData?.daisy));
        this.form.addControl('vds', this.fb.control(this.projectData?.vds));
        this.form.addControl(
          'kms',
          this.fb.control(parseInt(this.projectData?.estimatedKms))
        );
        this.form.addControl('bnr', this.fb.control(this.projectData?.bnr));
        this.form.addControl(
          'finish',
          this.fb.control(
            this.projectData?.projectNewVehicle.finishes,
            Validators.required
          )
        );
        this.form.addControl(
          'country',
          this.fb.control(this.projectData?.projectNewVehicle.nationalSalesPlan)
        );
        this.form.addControl(
          'model',
          this.fb.control(
            this.projectData?.projectNewVehicle.model,
            Validators.required
          )
        );
        this.form.addControl(
          'my',
          this.fb.control(this.projectData?.projectNewVehicle.modelYear)
        );
        this.form.addControl(
          'tmaimg',
          this.fb.control(
            this.projectData?.projectNewVehicle.tmaimg,
            Validators.required
          )
        );
        this.form.addControl(
          'launch',
          this.fb.control({
            value: this.projectData?.launch,
            disabled: !this.userIsController
          })
        );
        this.form.addControl(
          'dealerCode',
          this.fb.control(this.projectData?.dealer, Validators.required)
        );
        this.form.addControl('ceco', this.fb.control(this.projectData?.ceco));
        this.form.addControl(
          'use',
          this.fb.control(this.projectData?.projectNewVehicle.usePreview)
        );
        this.form.addControl(
          'exteriorColor',
          this.fb.control(this.projectData?.projectNewVehicle.exteriorColor)
        );
        this.form.addControl(
          'interiorColor',
          this.fb.control(this.projectData?.projectNewVehicle.interiorColor)
        );
        this.form.addControl(
          'destination',
          this.fb.control(this.projectData?.projectNewVehicle.destinationCode)
        );
        this.form.addControl(
          'optionals',
          this.fb.control(this.projectData?.projectNewVehicle.optionals)
        );
        this.form.addControl(
          'prNumbers',
          this.fb.control(this.projectData?.projectNewVehicle.prNumbers)
        );
        this.form.addControl(
          'prMotor',
          this.fb.control(this.projectData?.projectNewVehicle.prEngine)
        );
        this.form.addControl(
          'descriptionEngine',
          this.fb.control(this.projectData?.projectNewVehicle.engineDescription)
        );
        this.form.addControl('ea', this.fb.control(this.projectData?.ea));
        this.form.addControl(
          'registered',
          this.fb.control(this.projectData?.licensePlateManagement.management)
        );
        this.form.addControl(
          'specialType',
          this.fb.control(
            this.projectData?.costs.especialType,
            Validators.required
          )
        );
        this.form.addControl(
          'pressSubtype',
          this.fb.control(this.projectData?.costs.pressSubType)
        );
        this.form.addControl(
          'subtypeSeries',
          this.fb.control(this.projectData?.costs.serieSubType)
        );
        this.form.addControl(
          'materialType',
          this.fb.control(
            this.projectData?.costs.materialType,
            Validators.required
          )
        );
        this.form.addControl(
          'preseriesType',
          this.fb.control(
            this.projectData?.costs.preserieType,
            Validators.required
          )
        );
        this.form.addControl(
          'projectType',
          this.fb.control(
            this.projectData?.costs.projectType === 'MY/MP (MODELPFLEGE)'
              ? 'MY_MP'
              : this.projectData?.costs.projectType
          )
        );
        this.form.addControl(
          'projectML',
          this.fb.control(this.projectData?.costs.mlProject)
        );
        this.form.addControl(
          'preseriesCost',
          this.fb.control(this.projectData?.costs.preserieCost)
        );
        this.form.addControl(
          'seriesCost',
          this.fb.control(this.projectData?.costs.serieCost)
        );
        this.form.addControl(
          'transferToThird',
          this.fb.control(
            this.projectData?.projectNewVehicle.thirdPartyTransfer
          )
        );
        break;
      case this.projectTypeEnum.REGU:
        this.form.addControl(
          'area',
          this.fb.control(
            this.projectData?.department.area.id,
            Validators.required
          )
        );
        this.form.addControl(
          'departament',
          this.fb.control(
            { value: this.projectData?.department.id },
            Validators.required
          )
        );
        this.form.addControl(
          'reference',
          this.fb.control(this.projectData?.orderReference)
        );
        this.form.addControl(
          'date',
          this.fb.control(this.projectData?.requiredDate, Validators.required)
        );
        this.form.addControl(
          'returnDate',
          this.fb.control(this.projectData?.returnDate, Validators.required)
        );
        this.form.addControl(
          'vin',
          this.fb.control(
            this.projectData?.projectStockVehicle
              ? this.projectData?.projectStockVehicle.VIN
              : this.projectData?.projectRegularitationVehicle.VIN
          )
        );
        this.form.addControl('sop', this.fb.control(this.projectData?.sop));
        this.form.addControl(
          'kms',
          this.fb.control(parseInt(this.projectData?.estimatedKms))
        );
        this.form.addControl('bnr', this.fb.control(this.projectData?.bnr));
        this.form.addControl(
          'finish',
          this.fb.control(
            this.projectData?.projectRegularitationVehicle
              ? this.projectData?.projectRegularitationVehicle.finishes
              : '',
            Validators.required
          )
        );
        this.form.addControl(
          'country',
          this.fb.control(
            this.projectData?.projectRegularitationVehicle
              ? this.projectData?.projectRegularitationVehicle.nationalSalesPlan
              : ''
          )
        );
        this.form.addControl(
          'model',
          this.fb.control(
            this.projectData?.projectRegularitationVehicle
              ? this.projectData?.projectRegularitationVehicle.model
              : '',
            Validators.required
          )
        );
        this.form.addControl(
          'my',
          this.fb.control(
            this.projectData?.projectRegularitationVehicle
              ? this.projectData?.projectRegularitationVehicle.modelYear
              : ''
          )
        );
        this.form.addControl(
          'tmaimg',
          this.fb.control(
            this.projectData?.projectRegularitationVehicle
              ? this.projectData?.projectRegularitationVehicle.tmaimg
              : '',
            Validators.required
          )
        );
        this.form.addControl(
          'launch',
          this.fb.control({
            value: this.projectData?.launch,
            disabled: !this.userIsController
          })
        );
        this.form.addControl(
          'dealerCode',
          this.fb.control(this.projectData?.dealer, Validators.required)
        );
        this.form.addControl('ceco', this.fb.control(this.projectData?.ceco));
        this.form.addControl(
          'use',
          this.fb.control(
            this.projectData?.projectRegularitationVehicle
              ? this.projectData?.projectRegularitationVehicle.usePreview
              : ''
          )
        );
        this.form.addControl(
          'color',
          this.fb.control(
            this.projectData?.projectRegularitationVehicle
              ? this.projectData?.projectRegularitationVehicle
                  .exteriorColorDescription
              : '',
            Validators.required
          )
        );
        this.form.addControl(
          'destination',
          this.fb.control(
            this.projectData?.projectRegularitationVehicle
              ? this.projectData?.projectRegularitationVehicle.destinationCode
              : ''
          )
        );
        this.form.addControl('cops', this.fb.control(this.projectData?.daisy));
        this.form.addControl('vds', this.fb.control(this.projectData?.vds));
        this.form.addControl(
          'optionals',
          this.fb.control(
            this.projectData?.projectRegularitationVehicle
              ? this.projectData?.projectRegularitationVehicle.optionals
              : ''
          )
        );
        this.form.addControl(
          'prNumbers',
          this.fb.control(
            this.projectData?.projectRegularitationVehicle
              ? this.projectData?.projectRegularitationVehicle.prNumbers
              : ''
          )
        );
        this.form.addControl(
          'prMotor',
          this.fb.control(
            this.projectData?.projectRegularitationVehicle
              ? this.projectData?.projectRegularitationVehicle.prEngine
              : ''
          )
        );
        this.form.addControl(
          'descriptionEngine',
          this.fb.control(
            this.projectData?.projectRegularitationVehicle
              ? this.projectData?.projectRegularitationVehicle.engineDescription
              : ''
          )
        );
        this.form.addControl(
          'orderNumber',
          this.fb.control(
            this.projectData?.projectRegularitationVehicle
              ? this.projectData?.projectRegularitationVehicle.orderNumber
              : null
          )
        );
        this.form.addControl('ea', this.fb.control(this.projectData?.ea));
        this.form.addControl(
          'registered',
          this.fb.control(this.projectData?.licensePlateManagement.management)
        );
        break;
      case this.projectTypeEnum.OTHER:
        this.form.addControl(
          'checkedManagement',
          this.fb.control(this.projectData?.licensePlateManagement.management)
        );
        this.form.addControl(
          'plateNumber',
          this.fb.control(this.projectData?.licensePlateManagement.plateNumber)
        );
        this.form.addControl(
          'plateNumberDate',
          this.fb.control(this.projectData?.licensePlateManagement.plateDate)
        );
        this.form.addControl(
          'townHallCode',
          this.fb.control(this.projectData?.licensePlateManagement.townHallCode)
        );
        this.form.addControl(
          'insuranceType',
          this.fb.control(
            this.projectData?.licensePlateManagement.insuranceType
          )
        );
        this.form.addControl(
          'deliveryDate',
          this.fb.control(this.projectData?.licensePlateManagement.deliveryDate)
        );
        this.form.addControl(
          'brand',
          this.fb.control(
            this.projectData?.projectOtherVehicle.brand,
            Validators.required
          )
        );
        this.form.addControl(
          'reference',
          this.fb.control(this.projectData?.orderReference)
        );
        this.form.addControl(
          'launch',
          this.fb.control({
            value: this.projectData?.launch,
            disabled: !this.userIsController
          })
        );
        this.form.addControl(
          'dealerCode',
          this.fb.control(this.projectData?.dealer, Validators.required)
        );
        this.form.addControl('ceco', this.fb.control(this.projectData?.ceco));
        this.form.addControl(
          'date',
          this.fb.control(this.projectData?.requiredDate, Validators.required)
        );
        this.form.addControl(
          'use',
          this.fb.control(this.projectData?.projectOtherVehicle.usePreview)
        );
        this.form.addControl('cops', this.fb.control(this.projectData?.daisy));
        this.form.addControl('vds', this.fb.control(this.projectData?.vds));
        this.form.addControl(
          'returnDate',
          this.fb.control(this.projectData?.returnDate, Validators.required)
        );
        this.form.addControl(
          'kms',
          this.fb.control(parseInt(this.projectData?.estimatedKms))
        );
        this.form.addControl(
          'finishes',
          this.fb.control(this.projectData?.projectOtherVehicle.finishes)
        );
        this.form.addControl(
          'model',
          this.fb.control(
            this.projectData?.projectOtherVehicle.model,
            Validators.required
          )
        );
        this.form.addControl(
          'engine',
          this.fb.control(this.projectData?.projectOtherVehicle.engine)
        );
        this.form.addControl(
          'color',
          this.fb.control(
            this.projectData?.projectOtherVehicle.exteriorColorDescription
          )
        );
        this.form.addControl(
          'specialType',
          this.fb.control(this.projectData?.costs.especialType)
        );
        this.form.addControl(
          'materialType',
          this.fb.control(this.projectData?.costs.materialType)
        );
        this.form.addControl(
          'subtypeSeries',
          this.fb.control(this.projectData?.costs.serieSubType)
        );
        this.form.addControl(
          'seriesCost',
          this.fb.control(this.projectData?.costs.serieCost)
        );
        this.form.addControl(
          'emission',
          this.fb.control(this.projectData?.projectOtherVehicle.estimatedCO2)
        );
        this.form.addControl(
          'destination',
          this.fb.control(this.projectData?.projectOtherVehicle.destination)
        );
        this.form.addControl(
          'email',
          this.fb.control('', [
            Validators.pattern(
              '[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z]{2,4}$'
            )
          ])
        );
        this.form.addControl(
          'phone',
          this.fb.control('', [
            Validators.minLength(9),
            Validators.maxLength(9),
            Validators.pattern('^[0-9]*$')
          ])
        );
        break;
    }

    this.form
      .get('dealerCode')
      ?.valueChanges.subscribe((value: string | Dealers) => {
        this.filterDealers(value);
      });

    this.form.getRawValue();
  }

  private filterDealers(value: string | Dealers | null): void {
    if (!this.dealers || this.dealers.length === 0) {
      this.filteredDealers = [];
      return;
    }

    const filterValue = (
      typeof value === 'string' ? value : value?.name || ''
    ).toLowerCase();

    this.filteredDealers = this.dealers.filter((dealer) => {
      const dealerName = dealer.name.toLowerCase();
      const dealerCode = dealer.code.toLowerCase();
      return (
        dealerName.includes(filterValue) || dealerCode.includes(filterValue)
      );
    });
  }

  areaChange() {
    const areaSelected = this.form.get('area')?.value
      ? this.form.get('area')?.value
      : this.projectData?.department?.area?.id;

    this.orderService.getProjectDepartaments(areaSelected).subscribe({
      next: (data: any) => {
        this.departaments = data;
        this.form.get('departament')?.setValue(this.projectData?.department.id);
      },
      error: (error) => {
        console.error('Error fetching authorizers:', error);
      },
      complete: () => {
        console.log('Fetch complete');
      }
    });

    if (!areaSelected) {
      this.form.get('departament')?.disable();
    } else {
      this.form.get('departament')?.enable();
    }
  }

  updateDealerCode() {
    const selectedDealer: Dealers = this.form.value.dealerCode;
    if (selectedDealer?.preseries === false) {
      this.dialog.open(FeedbackModalComponent, {
        width: '530px',
        data: {
          text: i18next.t('nonPreseriesDealer'),
          close: true,
          theme: 'light'
        }
      });
    }
  }

  close() {
    this.picker['_destroyOverlay']();
    this.datePicker['_destroyOverlay']();
    this.plateNumberPicker['_destroyOverlay']();
    this.deliveryPicker['_destroyOverlay']();
  }

  closeSop() {
    this.sopPicker['_destroyOverlay']();
  }

  seeCostsDetail() {
    this.dialog.open(ModalTableCostsDetailComponent);
  }

  calculateCosts() {
    if (this.form.get('preseriesType')?.value === 'EMPTY') {
      this.dialog.open(FeedbackModalComponent, {
        data: {
          text: i18next.t('errorNA'),
          close: true,
          theme: 'ligth'
        }
      });
    } else if (this.form.get('tmaimg')?.value === '') {
      this.dialog.open(FeedbackModalComponent, {
        data: {
          text: i18next.t('errorTmaimg'),
          close: true,
          theme: 'ligth'
        }
      });
    } else if (this.form.get('materialType')?.value === '') {
      this.dialog.open(FeedbackModalComponent, {
        data: {
          text: i18next.t('errorMaterialType'),
          close: true,
          theme: 'ligth'
        }
      });
      // } else if (this.form.get('preseriesType')?.value === '') {
      //   this.dialog.open(FeedbackModalComponent, {
      //     data: {
      //       text: i18next.t('errorPreseriesType'),
      //       close: true
      //     }
      //   });
    } else if (this.form.get('projectType')?.value === 'EMPTY') {
      this.dialog.open(FeedbackModalComponent, {
        data: {
          text: i18next.t('errorProjectType'),
          close: true
        }
      });
    } else {
      this.orderService
        .getCalculateCosts(
          this.form.get('tmaimg')?.value,
          this.form.get('materialType')?.value,
          this.form.get('preseriesType')?.value,
          this.form.get('projectType')?.value
        )
        .subscribe({
          next: (data: any) => {
            this.form.get('preseriesCost')?.setValue(data.preserieCost);
            this.form.get('seriesCost')?.setValue(data.serieCost);
          },
          error: () => {
            this.dialog.open(FeedbackModalComponent, {
              data: {
                text: i18next.t('errorGetCosts'),
                close: true,
                theme: 'ligth'
              }
            });
          },
          complete: () => {
            console.log('Fetch complete');
          }
        });
    }
  }

  formatDateProject(value: any): any {
    if (value) {
      const localDate = new Date(value);
      const formattedDate = `${localDate.getFullYear()}-${(
        localDate.getMonth() + 1
      )
        .toString()
        .padStart(2, '0')}-${localDate.getDate().toString().padStart(2, '0')}`;

      return formattedDate;
    } else {
      return null;
    }
  }

  modifyProject() {
    this.spinner = true;
    const formValue = this.form.getRawValue();

    const modifyProjectData = {
      orderInfoDTO: {
        requestType: this.projectData?.requestType,
        comments: this.projectData?.observations,
        controllerUserId: this.controller ? this.controller.id : null,
        delegatedApproverUserId: this.delegatedApprover
          ? this.delegatedApprover.id
          : null
      },
      contactInfoDataDTO: formValue.phone
        ? {
            phoneNumber: formValue.phone,
            email: formValue.email
          }
        : null,
      projectData: {
        department: formValue.departament,
        orderReference: formValue.reference,
        launch: formValue.launch,
        dealer: formValue.dealerCode.code,
        ceco: formValue.ceco,
        needDate: this.formatDateProject(formValue.date),
        returnDate: this.formatDateProject(formValue.returnDate),
        sop: this.formatDateProject(formValue.sop),
        daisy: formValue.cops,
        vds: formValue.vds,
        ea: formValue.ea,
        estimatedKms: formValue.kms,
        bnr: formValue.bnr,
        newVehicle:
          this.projectData?.projectSubType !== 'NEW_FABRICATION'
            ? null
            : {
                finishes: formValue.finish,
                nationalSalesPlan: formValue.country,
                modelYear: formValue.my,
                model: formValue.model,
                tmaimg: formValue.tmaimg,
                usePreview: formValue.use,
                optionals: formValue.optionals,
                prNumbers: formValue.prNumbers,
                destinationCode: formValue.destination,
                prEngine: formValue.prMotor,
                engineDescription: formValue.descriptionEngine,
                exteriorColor: formValue.exteriorColor,
                interiorColor: formValue.interiorColor,
                orderNumber: formValue.orderNumber,
                thirdPartyTransfer: formValue.transferToThird
              },
        stockVehicle:
          this.projectData?.projectSubType === 'REGULARIZATION' &&
          this.stockVehicle
            ? {
                VIN: this.projectData?.projectStockVehicle.VIN,
                model: null
              }
            : null,
        regularitationVehicle:
          this.projectData?.projectSubType === 'REGULARIZATION' &&
          !this.stockVehicle
            ? {
                VIN: formValue.vin,
                finishes: formValue.finish,
                nationalSalesPlan: formValue.country,
                modelYear: formValue.my,
                model: formValue.model,
                tmaimg: formValue.tmaimg,
                usePreview: formValue.use,
                optionals: formValue.optionals,
                prNumbers: formValue.prNumbers,
                destinationCode: formValue.destination,
                prEngine: formValue.prMotor,
                engineDescription: formValue.descriptionEngine,
                exteriorColorDescription: formValue.color,
                orderNumber: formValue.orderNumber
              }
            : null,
        otherVehicle:
          this.projectData?.projectSubType !== 'OTHERS'
            ? null
            : {
                brand: formValue.brand,
                model: formValue.model,
                finishes: formValue.finishes,
                engine: formValue.engine,
                usePreview: formValue.use,
                estimatedCO2: formValue.emission,
                destination: formValue.destination,
                exteriorColorDescription: formValue.color
              },
        licensePlateManagement:
          this.projectData?.projectSubType !== 'OTHERS'
            ? {
                management: formValue.registered ? formValue.registered : false
              }
            : {
                management: formValue.checkedManagement
                  ? formValue.checkedManagement
                  : false,
                plateNumber: formValue.plateNumber,
                registrationDate: this.formatDateProject(
                  formValue.plateNumberDate
                ),
                townHallCode: formValue.townHallCode,
                insuranceType: formValue.insuranceType,
                deliveryDate: this.formatDateProject(formValue.deliveryDate)
              },
        costs:
          this.projectData?.projectSubType !== 'REGULARIZATION'
            ? {
                especialType: formValue.specialType,
                serieSubType: formValue.subtypeSeries,
                pressSubType:
                  this.projectData?.projectSubType !== 'OTHERS'
                    ? formValue.pressSubtype
                      ? formValue.pressSubtype
                      : 'SUBSTITUTION'
                    : null,
                materialType: formValue.materialType,
                preserieType: formValue.preseriesType,
                projectType: formValue.projectType,
                mlProject: formValue.projectML,
                preserieCost: formValue.preseriesCost,
                serieCost: formValue.seriesCost
              }
            : null
      },
      projectSubType: this.projectData?.projectSubType
    };

    this.orderService
      .modifyProject(modifyProjectData, this.projectData?.id)
      .subscribe({
        next: () => {
          this.spinner = false;
          this.dialog.open(FeedbackModalComponent, {
            width: '400px',
            data: {
              text: i18next.t('projectModified'),
              close: true,
              theme: 'ligth'
            }
          });
        },
        error: () => {
          this.spinner = false;
          this.dialog.open(FeedbackModalComponent, {
            width: '400px',
            data: {
              text: i18next.t('projectErrorModified'),
              close: true,
              theme: 'ligth'
            }
          });
        },
        complete: () => {
          console.log('Fetch complete');
        }
      });
  }

  private applyDealer(dealer: Dealers): void {
    this.cecos = dealer.cecos ? [...dealer.cecos] : [];

    const cecoControl = this.form.get('ceco');
    if (!cecoControl) {
      return;
    }

    this.form.get('launch')?.patchValue(dealer.launch);

    cecoControl.enable({ emitEvent: false });

    if (this.cecos.length === 1) {
      cecoControl.setValue(this.cecos[0], { emitEvent: false });
    } else {
      cecoControl.setValue('', { emitEvent: false });
    }
  }

  private setCecoInit(dealer: Dealers): void {
    this.cecos = dealer.cecos ? [...dealer.cecos] : [];

    const cecoControl = this.form.get('ceco');
    if (cecoControl && cecoControl.value) {
      cecoControl.setValue(cecoControl.value, { emitEvent: false });
    } else if (cecoControl && !cecoControl.value) {
      if (this.cecos.length === 1) {
        cecoControl.setValue(this.cecos[0], { emitEvent: false });
      } else {
        cecoControl.setValue('', { emitEvent: false });
      }
    }
  }

  private clearCecos(): void {
    this.cecos = [];
    const cecoControl = this.form.get('ceco');
    if (!cecoControl) {
      return;
    }
    cecoControl.setValue('', { emitEvent: false });
    cecoControl.disable({ emitEvent: false });
  }

  updateDealerCodeAC(event: any) {
    const dealer: Dealers = event.option.value;

    if (dealer) {
      this.applyDealer(dealer);
    } else {
      this.clearCecos();
    }
    this.updateDealerCode();
  }

  updateDealerCodeInit(dealerCode: any) {
    const dealer = this.dealers.find((d) => d.code === dealerCode);
    if (dealer) {
      this.setCecoInit(dealer);
    } else {
      this.clearCecos();
    }

    this.updateDealerCode();
  }
}
